
import Vue from 'vue';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import { mapState, mapActions } from 'pinia';
import { mm2px } from '@/utils';
import { getScaledProductImageDPI } from '@/utils/areaHelper';
import { PREVIEW_IMAGE_BOX } from '@/web-components/import-wizard-v2/constants';
import { AnnotationShape } from '@/web-components/import-wizard-v2/typings/common';

export default Vue.extend({
  name: 'ProductPreview',

  data() {
    return {
      PREVIEW_IMAGE_BOX,
    };
  },

  computed: {
    ...mapState(useProductStore, [
      'selectedPrintPosition',
      'selectedVariant',
      'activePosition',
    ]),
    ...mapState(useMirrorStore, ['currentMirrorSettings']),
    ...mapState(useShapeStore, ['positionShapes']),

    selectedVariantImageUrl(): string | undefined {
      if (this.activePosition && this.selectedVariant) {
        const variantImage = this.selectedVariant.images?.find(
          (img) => img.printPositionID === this.activePosition.id
        );
        return variantImage ? variantImage.imageWebUrl : undefined;
      }
      return undefined;
    },

    activePositionShapes() {
      if (this.selectedPrintPosition && this.selectedPrintPosition.id) {
        const mirrorShapesFromPosition = this.getActiveMirrorShapes();
        const mirrorShapesFromPositionInArea = [] as AnnotationShape[];

        let selectedShapes = this.positionShapes(
          this.selectedPrintPosition.id
        ).filter((x) => x.isInArea) as AnnotationShape[];

        mirrorShapesFromPosition.forEach((x) => {
          if (
            selectedShapes.findIndex((y) => y.id === x.originalShapeId) !== -1
          ) {
            mirrorShapesFromPositionInArea.push(x);
          }
        });

        selectedShapes = [...selectedShapes, ...mirrorShapesFromPositionInArea];

        const mappedPositions = selectedShapes.map((x) => {
          if (this.activePosition.originalImageWidthPx) {
            const scaledDPI = getScaledProductImageDPI(
              this.activePosition.originalImageWidthPx,
              this.activePosition.originalImageHeightPx,
              this.activePosition.originalImageDpi,
              PREVIEW_IMAGE_BOX
            );

            return {
              id: x.id,
              x: mm2px(x.xOnProductMM, scaledDPI),
              y: mm2px(x.yOnProductMM, scaledDPI),
              width: mm2px(x.widthOnProductMM, scaledDPI),
              height: mm2px(x.heightOnProductMM, scaledDPI),
              pngFileUrl: x.pngFile
                ? URL.createObjectURL(x.pngFile as Blob)
                : '',
              rotation: x.rotation,
            };
          }
        });

        return mappedPositions;
      }
      return [];
    },
  },
  methods: {
    ...mapActions(useMirrorStore, ['getActiveMirrorShapes']),
  },
});
